import {useTranslation} from "react-i18next";
import useTemplate from "@shared/hooks/useTemplate";

interface Props {
  eyecatcher: string;
}

export const ProductEyeCatcher = ({eyecatcher}: Props) => {
  const {t} = useTranslation();
  const { isApodiscounterPl } = useTemplate();
  
  if (!eyecatcher) return null;

  const pctMatch = eyecatcher.match(/-?(\d+)%/);
  if (!pctMatch) return null;

  const overlayClasses = `product-image-overlay${isApodiscounterPl ? ' product-image-overlay_pl' : ''}`;

  return (
    <>
      <div
        className={overlayClasses}
        aria-hidden="true"
      >
        <div className="product-card__discount-percentage">
          {pctMatch[1]}
          <span className="product-card__discount-percent-sign">%</span>
        </div>
        <div className="product-card__discount-label">
          {t("search.hits.eyecatcher.save")}
        </div>
      </div>
      <span className="sr-only">
        {pctMatch[1]}% {t("search.hits.eyecatcher.save")}
      </span>
    </>
  );
};
